import styled from "styled-components";
import { useEffect, useState, useRef } from "react";
import { gql, useQuery, useLazyQuery } from "@apollo/client";
import { captureException } from "@sentry/react";
import { useNavigate, useSearchParams } from "react-router-dom";

import ReviewAdPlan from "./ReviewAdPlan";
import LoadingBox from "components/other/LoadingBox";
import BoxLoadingSpinner from "components/other/BoxLoadingSpinner";
import Backdrop from "components/other/Backdrop";
import MessageWindow from "components/other/MessageWindow";

const ModalWrap = styled.div`
  width: 100%;
  margin: 0;
  padding: 0;
`;

export default () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [selectedPlan, setSelectedPlan] = useState(() => {
    const plan = searchParams.get("plan");

    return plan ? Number(plan) : 1;
  });
  const [checkoutLoading, setCheckoutLoading] = useState(false);
  const [errorWindow, setErrorWindow] = useState(false);

  // Fetch data
  const GET_AD_PLAN_BILLING_DATA = gql`
    query GetAdPlanBillingData {
      adPlanBillingData {
        billingAddress {
          id
          name
          country
        }
        prices {
          product
          price
        }
        vatRate
        adPlan
        subscription {
          expires
        }
      }
    }
  `;

  const { data, error, refetch } = useQuery(GET_AD_PLAN_BILLING_DATA, {
    fetchPolicy: "network-only",
  });

  if (error) {
    console.log("Fetching ad plan billing data error", error);
    captureException(error);
  }

  // Error handlig
  const openErrorWindow = () => {
    setErrorWindow(true);
  };

  const handleModalClose = (modal) => {
    if (modal === "error") {
      setErrorWindow(false);
    }
  };

  // handle checkout
  // Get Stripe checkout URL
  const GET_STRIPE_CHECKOUT = gql`
    query GetStripeCheckout($pack: String!) {
      getStripeCheckout(pack: $pack) {
        url
      }
    }
  `;

  const [getStripeCheckout] = useLazyQuery(GET_STRIPE_CHECKOUT);

  // handle Stripe checkout
  const stripeCheckout = async (product) => {
    //return;
    try {
      if (checkoutLoading) return;
      if (!product) return;

      setCheckoutLoading(true);

      //const planName = plan + "_ad_plan";

      // create checkout session
      const checkout = await getStripeCheckout({
        variables: {
          pack: product,
        },
        fetchPolicy: "network-only",
      });

      const { loading, error, data } = checkout;

      setCheckoutLoading(false);

      if (error) {
        console.log("Get stripe checkout error", error);
        captureException(error);
      }

      if (data && !loading) {
        // console.log("checkout data", data);
        if (data.getStripeCheckout?.url) {
          //console.log("data.getStripeCheckout.url", data.getStripeCheckout.url);
          window.location = data.getStripeCheckout.url;
        }
      }
    } catch (error) {
      captureException(error);
      setCheckoutLoading(false);
      return;
    }
  };

  useEffect(() => {
    if (selectedPlan > 7) navigate("/advertising-plans");
  }, [selectedPlan]);

  const onGoldPlanSelect = (plan) => {
    if (!data) return;

    if (data.adPlanBillingData.adPlan === plan) return;

    setSelectedPlan(plan);
  };

  console.log("data", data);
  //console.log("selectedPlan", selectedPlan);

  // check if active plan is different to selected plan
  useEffect(() => {
    if (data && selectedPlan) {
      if (data.adPlanBillingData.adPlan === selectedPlan) {
        navigate("/manage-ad-plan");
      }
    }
  }, [data, selectedPlan]);

  return (
    <>
      {!data && (
        <LoadingBox>
          <BoxLoadingSpinner height="230px" />
        </LoadingBox>
      )}
      {data && (
        <ReviewAdPlan
          data={data}
          stripeCheckout={stripeCheckout}
          selectedPlan={selectedPlan}
          onGoldPlanSelect={onGoldPlanSelect}
        />
      )}
      {errorWindow && (
        <ModalWrap>
          <Backdrop
            onClick={handleModalClose}
            parameters="error"
            background="rgba(0, 0, 0, 0.7)"
          />
          <MessageWindow handleModalClose={handleModalClose} type="error" />
        </ModalWrap>
      )}
    </>
  );
};
